import { ChevronRightIcon } from '@heroicons/react/24/outline';
import type { ColumnsType } from 'antd/es/table';
import Table from 'antd/es/table';
import cn from 'classnames';

import type { PayoutReasonCodeItem } from 'api';

type Props = {
  title: string;
  className?: string;
  totalPercentage: number;
  columns: ColumnsType<PayoutReasonCodeItem>;
  data: PayoutReasonCodeItem[];
  onHeaderClick: () => void;
};

export function StatsTable({
  title,
  className,
  totalPercentage,
  columns,
  data,
  onHeaderClick
}: Props) {
  return (
    <div
      className="data-table__wrapper w-full"
      data-testid="dashboard-payouts-reason-overview"
    >
      <div className="w-full overflow-hidden rounded-2xl bg-white shadow-plain-lg">
        <Table
          className={cn('w-full text-content-primary', className)}
          dataSource={data}
          columns={columns}
          pagination={false}
          rowKey="id"
          size="small"
          tableLayout="fixed"
          rowClassName="data-table__row group text-sm hover:bg-surface-muted"
          title={() => (
            <button
              type="button"
              onClick={onHeaderClick}
              className="group flex w-full items-center rounded-t-lg bg-white px-2 py-3.5 text-left font-medium hover:text-content-primary"
            >
              <span className="flex items-baseline gap-1">
                <span className="text-md font-bold">{title} payouts:</span>
                <span title={`${totalPercentage}%`}>
                  {Math.round(totalPercentage)}%
                </span>
              </span>
              <span className="invisible ml-2 flex size-5 items-center justify-center rounded-full transition-colors group-hover:visible group-hover:bg-border-strong">
                <ChevronRightIcon className="size-3 stroke-2" />
              </span>
            </button>
          )}
        />
      </div>
    </div>
  );
}
